import { Button, Tabs, TabsProps, UploadFile } from 'antd';
import { MasterSubCategoryData } from 'domain/entities/MasterEntity';
import {
    ListedPropertyDetailMemberAuctionProperty,
    ListedPropertyRoomGetAssessmentDetail,
} from 'domain/entities/PropertyEntity';
import { AppProps } from 'presentation/App';
import { BUYER_CLASSIFICATION } from 'presentation/components/HeaderRightComponent';
import { modalHelpers } from 'presentation/components/Modal/Modal.service';
import { ConfirmModalProps } from 'presentation/components/Modal/Modal.type';
import { openErrorNoti, openSuccessNoti } from 'presentation/components/Notification';
import { PageTitle } from 'presentation/components/PageTitle';
import { setVisibleCU01702 } from 'presentation/redux/features/CU/CU01702Slice';
import {
    completeFetching,
    showAlert,
    showConfirm,
    startFetching,
} from 'presentation/redux/features/app/appSlice';
import { useAppDispatch } from 'presentation/redux/hooks';
import { AUTH_ROUTES, PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { MASTER_CATEGORY_LIST } from 'utilities/constants/COMMON';
import getMessage from 'utilities/constants/MESSAGE';
import { commonHelpers } from 'utilities/helpers';
import { TodoEntity } from '../CU-002-02/models/CardModel';
import UploadImage from './component/Upload';
import TAB1Component from './tab1';
import TAB1_1Component from './tab1_1';
import TAB2Component from './tab2';
import TAB3Component from './tab3';

const SCU00203T1 = [
    '0001000010',
    '0001000020',
    '0001000030',
    '0001000040',
    '0001000050',
    '0001000060',
    '0001000065',
    '0001000070',
];
const CU00203Page = (prop: AppProps) => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { listedPropertyId, propertyId, auctionId } = useParams();
    const [searchParams] = useSearchParams();
    const { currentTodo, memberTodo, bidPrice, purchaseAmount } = location.state ?? {
        currentTodo: '',
        memberTodo: '',
        bidPrice: '',
        purchaseAmount: 0,
    };
    const [detailAssessment, setDetailAssessment] =
        useState<ListedPropertyDetailMemberAuctionProperty>();
    const [detailRoomAssessment, setDetailRoomAssessment] =
        useState<ListedPropertyRoomGetAssessmentDetail>();
    const [options, setOptions] = useState<MasterSubCategoryData[]>([]);
    const [activeKey, setActiveKey] = useState<string>('1');
    const [dataNavigate, setDataNavigate] = React.useState<any>();
    const [initFile, setInitFiles] = useState<UploadFile[]>([]);
    React.useEffect(() => {
        if (detailAssessment) {
            setDataNavigate({
                name: detailAssessment.name,
                rateBuyNow: detailAssessment.rateBuyNow,
                rateHighestAuctionNow: detailAssessment.rateHighestAuctionNow,
                currentHighestAuctionPrice: detailAssessment.currentHighestAuctionPrice,
                askingSalePriceUpperLimit: detailAssessment.askingSalePriceUpperLimit,
                yourAuctionBid: detailAssessment.yourAuctionBid,
                rent: detailAssessment.rent,
                rateYourAuctionBids: detailAssessment.rateYourAuctionBids,
                auctionId: detailAssessment.auctionId,
                currentScheduleSeq: detailAssessment.currentScheduleSeq,
                auctionTime: detailAssessment.auctionTime,
                auctionStatus: detailAssessment.auctionStatus,
            });
            if(detailAssessment.brokerageContractFile.length > 0 && detailAssessment.agencyContractFile.length > 0){
                let urlFiles = [];
                if (searchParams.get('type') == String(BUYER_CLASSIFICATION)) {
                    urlFiles = [
                        ...detailAssessment.leaseContractFile,
                        ...detailAssessment.propertyContractFile,
                    ];
                } else {
                    urlFiles = [
                        ...detailAssessment.brokerageContractFile,
                        ...detailAssessment.agencyContractFile,
                    ];
                }
                const mapArray = urlFiles.map((item, index) => {
                    return {
                        uid: String(index),
                        url: item,
                        name: createFileName(item),
                        status: 'done',
                    } as UploadFile;
                });
                setInitFiles(mapArray);
                if (SCU00203T1.includes(currentTodo?.todoCode)) {
                    const {
                        brokerageContractFile,
                        agencyContractFile,
                        leaseContractFile,
                        propertyContractFile,
                    } = location.state ?? {
                        brokerageContractFile: [],
                        agencyContractFile: [],
                        leaseContractFile: [],
                        propertyContractFile: [],
                    };
                    let urlFiles = [];
                    if (searchParams.get('type') == String(BUYER_CLASSIFICATION)) {
                        urlFiles = [...leaseContractFile, ...propertyContractFile];
                    } else {
                        urlFiles = [...brokerageContractFile, ...agencyContractFile];
                    }
                    const mapArray = urlFiles.map((item, index) => {
                        return {
                            uid: String(index),
                            url: item,
                            name: createFileName(item),
                            status: 'done',
                        } as UploadFile;
                    });
                    setInitFiles(mapArray);
                }
            }
        }

    }, [detailAssessment]);
    const createFileName = (url: string) => {
        // const typeContract = url.substring(0, url.lastIndexOf('/'));
        // const type = typeContract.substring(typeContract.lastIndexOf('/') + 1, typeContract.length);
        // const rawTime = decodeURI(url.substring(url.lastIndexOf('/') + 1, url.indexOf('?'))).split('_').at(0);
        // const time = dayjs(String(Number(rawTime)/1000000),'YYYYMMDDhhmmss').format(DATE_FORMAT.FORMAT_FULL);
        return decodeURI(url.substring(url.lastIndexOf('/') + 1, url.indexOf('?')));
    };

    useEffect(() => {
        (async () => {
            if (SCU00203T1.includes(currentTodo?.todoCode)) {
                Promise.all([
                    getListedPropertyRoomGetAssessmentDetail({
                        listedPropertyId: Number(listedPropertyId),
                    }),
                    initiateOptions(),
                ]);
            } else {
                await getListedPropertyDetailMemberAuctionProperty({
                    listedPropertyId: Number(listedPropertyId),
                });
            }
        })();
    }, []);

    const headerComponent = () => {
        return (
            <>
                <div className="flex space justify-between w-full pr-[20px]">
                    <div className="flex flex-start items-center gap-8">
                        <div>
                            {searchParams.get('type') == String(BUYER_CLASSIFICATION)
                                ? '取引詳細'
                                : '物件詳細'}
                        </div>
                    </div>
                </div>
            </>
        );
    };
    const getListedPropertyDetailMemberAuctionProperty = async (params: {
        listedPropertyId: number;
    }) => {
        try {
            dispatch(startFetching());
            const response = await prop.propertyUseCase.getDetailAuctionOfMember(params);
            getListedPropertyRoomGetAssessmentDetail({
                listedPropertyId: Number(listedPropertyId),
            })
            if (response) {
                // if (response.result.isLogin) {
                    setDetailAssessment(response.result);
                // }
                //  else {
                //     navigate(`${AUTH_ROUTES.PATH}/${AUTH_ROUTES.SUB.CU_001_00}`);
                // }
            }
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };
    const getListedPropertyRoomGetAssessmentDetail = async (params: {
        listedPropertyId: number;
    }) => {
        try {
            dispatch(startFetching());
            const response =
                await prop.propertyUseCase.getListedPropertyRoomGetAssessmentDetail(params);
            if (response) {
                setDetailRoomAssessment(response);
            }
        } catch (error: any) {
            openSuccessNoti();
        } finally {
            dispatch(completeFetching());
        }
    };
    const initiateOptions = async () => {
        try {
            dispatch(startFetching());
            const options = await Promise.all([
                prop.masterUseCase.getMasterSubCategoryList({
                    categoryCode: MASTER_CATEGORY_LIST.CLASSIFICATION_BATH_AND_TOILET,
                }),
                prop.masterUseCase.getMasterSubCategoryList({
                    categoryCode: MASTER_CATEGORY_LIST.INDOOR_LAUNDRY_AREA_CLASSIFICATION,
                }),
                prop.masterUseCase.getMasterSubCategoryList({
                    categoryCode: MASTER_CATEGORY_LIST.STATUS_CLASSIFICATION,
                }),
                prop.masterUseCase.getMasterSubCategoryList({
                    categoryCode: MASTER_CATEGORY_LIST.ROOM_LAYOUT_DIV,
                }),
            ]);
            setOptions(options);
        } catch (error: any) {
            openSuccessNoti();
        } finally {
            dispatch(completeFetching());
        }
    };
    const onChange = (key: string) => {
        setActiveKey(key);
    };
    const checkCancelSellingPrice = async () => {
        try {
            dispatch(startFetching());
            if (prop.propertyUseCase) {
                const response = await prop.propertyUseCase.checkCancelListedProperty({
                    auctionId: Number(detailAssessment?.auctionId),
                });
                if (response.status == '200') {
                    cancelSellingPrice();
                }
            }
        } catch (error: any) {
            if (error && error.message) {
                const alertProps = {
                    message: error.message,
                    type: 'warning',
                    title: '確認',
                    okText: 'OK',
                    onOk: () => backToDashBoard(),
                };
                dispatch(showAlert(alertProps));
            }
        } finally {
            dispatch(completeFetching());
        }
    };

    const cancelSellingPrice = () => {
        dispatch(setVisibleCU01702());
    };

    const checkChangeSellingPrice = async () => {
        try {
            dispatch(startFetching());
            if (prop.propertyUseCase) {
                const response = await prop.propertyUseCase.checkChangeSellingPrice({
                    auctionId: Number(detailAssessment?.auctionId),
                });
                if (response.status == '200') {
                    changeSellingPrice();
                }
            }
        } catch (error: any) {
            if (error && error.message) {
                const alertProps = {
                    message: error.message,
                    type: 'warning',
                    title: '確認',
                    okText: 'OK',
                    onOk: () => backToDashBoard(),
                };
                dispatch(showAlert(alertProps));
            }
        } finally {
            dispatch(completeFetching());
        }
    };

    const backToDashBoard = () => {
        navigate(PRIVATE_ROUTES.PATH + '/' + PRIVATE_ROUTES.SUB.DASHBOARD + '?tab=2');
    };

    const changeSellingPrice = () => {
        navigate(
            `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_036_01}/${detailAssessment?.propertyId}/${listedPropertyId}/${detailAssessment?.auctionId}`,
        );
    };
    const buttonSellerComponent = () => {
        switch (currentTodo?.todoCode) {
            //部屋情報入力
            case '0001000010':
                return (
                    <div className="button-group">
                        <Button
                            type="primary"
                            onClick={() => {
                                navigate(
                                    `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_031_01}/${propertyId}/${listedPropertyId}`,
                                );
                            }}
                        >
                            部屋情報を入力する
                        </Button>
                    </div>
                );
            //査定依頼
            case '0001000020':
                return (
                    <div className="button-group">
                        <Button
                            type="primary"
                            onClick={() =>
                                navigate(
                                    `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_035_01}/${propertyId}/${listedPropertyId}`,
                                )
                            }
                        >
                            査定を依頼する
                        </Button>
                    </div>
                );
            //本人確認
            case '0001000030':
                return (
                    <div className="button-group">
                        <Button
                            type="primary"
                            onClick={() =>
                                navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_004_00}`)
                            }
                        >
                            本人確認に進む
                        </Button>
                    </div>
                );
            //出品価格の設定
            case '0001000060':
                return (
                    <div className="button-group">
                        <Button
                            type="primary"
                            onClick={() => {
                                navigate(
                                    `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_036_01}/${propertyId}/${listedPropertyId}/${auctionId ?? ''}`,
                                );
                            }}
                        >
                            出品価格の設定
                        </Button>
                    </div>
                );
            case '0001000065':
                return (
                    <div className="button-group">
                        <Button
                            type="primary"
                            disabled={true}
                            onClick={() => {
                                navigate(
                                    `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_036_01}/${propertyId}/${listedPropertyId}/${auctionId ?? ''}`,
                                );
                            }}
                        >
                            出品価格の設定
                        </Button>
                    </div>
                );
            case '0001000090':
                return (
                    <div className="button-group">
                        <Button type="primary" onClick={checkChangeSellingPrice}>
                            価格変更申請
                        </Button>

                        <Button type="primary" danger onClick={checkCancelSellingPrice}>
                            出品取り下げ申請
                        </Button>
                    </div>
                );
            //出品継続意思確認
            case '0001000100':
                return (
                    <div className="button-group">
                        <Button
                            type="primary"
                            onClick={() => {
                                const confirmProps: ConfirmModalProps = {
                                    title: '出品を継続しますか？',
                                    message: (
                                        <>
                                            {' '}
                                            継続には媒介契約の再締結が必要です。
                                            <br />
                                            また、継続にあたって売却希望価格の変更が
                                            <br />
                                            可能です。
                                        </>
                                    ),
                                    okText: '売却希望価格を変更',
                                    cancelText: '変更せずに契約の再締結に進む',
                                    closeText: 'キャンセル',
                                    type: 'info',
                                    onOk: async () => {
                                        navigate(
                                            `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_036_01}/${propertyId}/${listedPropertyId}/${auctionId}`,
                                        );
                                    },
                                    onCancel: async () => {
                                        const payload = {
                                            auctionId: auctionId || '',
                                            type: 'PTN-A1',
                                            askingSalePriceUpperLimit:
                                                detailAssessment?.askingSalePriceUpperLimit || 0,
                                            askingSalePriceLowerLimit:
                                                detailAssessment?.askingSalePriceLowerLimit || 0,
                                            listedPropertyId: Number(listedPropertyId) || 0,
                                            dealId: Number(searchParams.get('dealId')) || 0,
                                        };
                                        try {
                                            const response =
                                                await prop.propertyUseCase.processBeforePeriod(
                                                    payload,
                                                );
                                            if (response) {
                                                openSuccessNoti({
                                                    description: getMessage('S0329'),
                                                });
                                                navigate(
                                                    `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_002_02}`,
                                                );
                                            }
                                        } catch (e) {
                                            modalHelpers.showAlert(
                                                commonHelpers.getAlertPropsByErrCode('N0930'),
                                            );
                                        }
                                    },
                                };
                                dispatch(showConfirm(confirmProps));
                            }}
                        >
                            出品を継続する
                        </Button>

                        <Button
                            type="primary"
                            danger
                            onClick={() => {
                                const confirmProps: ConfirmModalProps = {
                                    title: '出品を中止します',
                                    message: (
                                        <>
                                            {' '}
                                            当社買取価格での買取が可能ですが、
                                            <br />
                                            このまま出品を中止しますか
                                        </>
                                    ),
                                    okText: '当社買取価格での買取を希望する',
                                    cancelText: '出品を中止する',
                                    closeText: 'キャンセル',
                                    type: 'warning',
                                    onOk: async () => {
                                        const payload = {
                                            auctionId: auctionId || '',
                                            type: 'PTN-B',
                                            askingSalePriceUpperLimit:
                                                detailAssessment?.askingSalePriceUpperLimit || 0,
                                            askingSalePriceLowerLimit:
                                                detailAssessment?.askingSalePriceLowerLimit || 0,
                                            listedPropertyId: Number(listedPropertyId) || 0,
                                            dealId: Number(searchParams.get('dealId')) || 0,
                                        };
                                        try {
                                            const response =
                                                await prop.propertyUseCase.processBeforePeriod(
                                                    payload,
                                                );
                                            if (response) {
                                                openSuccessNoti({
                                                    description: getMessage('S0328'),
                                                });
                                                navigate(
                                                    `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_002_02}`,
                                                );
                                            }
                                        } catch (e) {
                                            modalHelpers.showAlert(
                                                commonHelpers.getAlertPropsByErrCode('N0930'),
                                            );
                                        }
                                    },
                                    onCancel: async () => {
                                        const payload = {
                                            auctionId: auctionId || '',
                                            type: 'PTN-C',
                                            askingSalePriceUpperLimit:
                                                detailAssessment?.askingSalePriceUpperLimit || 0,
                                            askingSalePriceLowerLimit:
                                                detailAssessment?.askingSalePriceLowerLimit || 0,
                                            listedPropertyId: Number(listedPropertyId) || 0,
                                            dealId: Number(searchParams.get('dealId')) || 0,
                                        };
                                        try {
                                            const response =
                                                await prop.propertyUseCase.processBeforePeriod(
                                                    payload,
                                                );
                                            if (response) {
                                                openSuccessNoti({
                                                    description: getMessage('S0327'),
                                                });
                                                navigate(
                                                    `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_002_02}`,
                                                );
                                            }
                                        } catch (e) {
                                            modalHelpers.showAlert(
                                                commonHelpers.getAlertPropsByErrCode('N0930'),
                                            );
                                        }
                                    },
                                };
                                dispatch(showConfirm(confirmProps));
                            }}
                        >
                            出品を中止する
                        </Button>
                    </div>
                );
            //代理契約内容の確認
            case '0001000130':
                return (
                    <div className="button-group">
                        <Button
                            type="primary"
                            onClick={() => {
                                navigate(
                                    `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_063_01}/${listedPropertyId}`,
                                );
                            }}
                        >
                            代理契約内容の確認
                        </Button>
                    </div>
                );
            //決済日の設定
            //登記書類の用意
            //一括返済計算書の登録
            //精算書の確認
            //最終確認日時の登録
            case '0001000170':
            case '0001000180':
            case '0001000190':
            case '0001000200':
            case '0001000210':
                return (
                    <div className="button-group">
                        {memberTodo.find((e: any) => e.todoCode == '0001000170')?.todoExecStatus ==
                            'DOING' && (
                            <Button
                                type="primary"
                                onClick={() => {
                                    navigate(
                                        `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_012_01}`,
                                    );
                                }}
                            >
                                決済日の設定
                            </Button>
                        )}

                        {memberTodo.find((e: any) => e.todoCode == '0001000190')?.todoExecStatus ==
                            'DOING' && (
                            <Button
                                type="primary"
                                onClick={() => {
                                    navigate(
                                        `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_043_01}/${searchParams.get('settlementId')}`,
                                    );
                                }}
                            >
                                一括返済計算書の登録
                            </Button>
                        )}

                        {memberTodo.find((e: any) => e.todoCode == '0001000200')?.todoExecStatus ==
                            'DOING' && (
                            <Button
                                type="primary"
                                onClick={() => {
                                    navigate(
                                        `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_060_01}/${searchParams.get('settlementId')}/${searchParams.get('dealId')}`,
                                    );
                                }}
                            >
                                精算書の確認
                            </Button>
                        )}

                        {memberTodo.find((e: any) => e.todoCode == '0001000210')?.todoExecStatus ==
                            'DOING' && (
                            <Button
                                type="primary"
                                onClick={() => {
                                    navigate(
                                        `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_062_01}/${searchParams.get('settlementId')}`,
                                    );
                                }}
                            >
                                最終確認日時の登録
                            </Button>
                        )}
                        {memberTodo.find((e: any) => e.todoCode == '0001000210')?.todoExecStatus ==
                            'DONE' && (
                            <Button
                                type="primary"
                                onClick={() => {
                                    navigate(
                                        `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_062_02}/${searchParams.get('settlementId')}`,
                                    );
                                }}
                            >
                                最終確認日時の確定
                            </Button>
                        )}
                    </div>
                );
            //最終確認日時の同意
            case '0001000220':
                return (
                    <div className="button-group">
                        <Button
                            type="primary"
                            onClick={() => {
                                navigate(
                                    `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_062_02}/${searchParams.get('settlementId')}`,
                                );
                            }}
                        >
                            最終確認日時の確定
                        </Button>
                    </div>
                );
            default:
                return <div className="button-group"></div>;
        }
    };

    const buttonBuyerComponent = () => {
        switch (currentTodo?.todoCode) {
            //T2_1
            case '0002000020':
                return (
                    <div className="button-group">
                        <Button
                            style={{ background: '#4BCAE5' }}
                            type="primary"
                            onClick={() => {
                                navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_051_01}/${listedPropertyId}`);
                            }}
                        >
                            シミュレーションへ
                        </Button>

                        <Button
                            type="primary"
                            onClick={() => {
                                navigate(
                                    `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_013_01}/${listedPropertyId}`,
                                    { state: { ...dataNavigate } },
                                );
                            }}
                        >
                            入札する
                        </Button>
                    </div>
                );
            //購入の申込
            case '0002000030':
                if(currentTodo.todoExecStatus !== 'DONE'){
                    return (
                        <div className="button-group">
                            <Button
                                type="primary"
                                onClick={() => {
                                    navigate(
                                        `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_014_02}/${auctionId}`,
                                    );
                                }}
                            >
                                購入申込に進む
                            </Button>
                        </div>
                    );  
                } else {
                    return (
                    <div className="button-group">
                    </div>
                );
            }
            //不動産売買契約締結予定日時の設定
            case '0002000060':
                return (
                    <div className="button-group">
                        <Button
                            type="primary"
                            onClick={() => {
                                navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_012_01}`);
                            }}
                        >
                            締結予定日時の設定
                        </Button>
                    </div>
                );

            //ローン再申請
            case '0002000110':
                return (
                    <div className="button-group">
                        <Button
                            type="primary"
                            onClick={() => {
                                navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_012_01}`);
                            }}
                        >
                            管理者にメッセージ
                        </Button>
                    </div>
                );
            //決済日の設定
            //火災保険申込済書の登録
            //賃貸管理移管契約日時の設定
            //賃貸管理移管契約の締結
            //登記書類の用意
            //精算書の確認
            //最終確認日時の登録
            //最終確認日時の同意
            case '0002000120':
            case '0002000130':
            case '0002000140':
            case '0002000150':
            case '0002000160':
            case '0002000170':
            case '0002000180':
            case '0002000190':
                return (
                    <div className="button-group">
                        {memberTodo.find((e: any) => e.todoCode == '0002000120')?.todoExecStatus ==
                            'DOING' && (
                            <Button
                                type="primary"
                                onClick={() => {
                                    navigate(
                                        `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_012_01}`,
                                    );
                                }}
                            >
                                決済日の設定
                            </Button>
                        )}

                        {memberTodo.find((e: any) => e.todoCode == '0002000130')?.todoExecStatus ==
                            'DOING' && (
                            <Button
                                type="primary"
                                onClick={() => {
                                    navigate(
                                        `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_061_01}/${searchParams.get('settlementId')}`,
                                    );
                                }}
                            >
                                火災保険申込済書の登録
                            </Button>
                        )}

                        {memberTodo.find((e: any) => e.todoCode == '0002000140')?.todoExecStatus ==
                            'DOING' && (
                            <Button
                                type="primary"
                                onClick={() => {
                                    navigate(
                                        `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_012_01}`,
                                    );
                                }}
                            >
                                締結予定日時の設定
                            </Button>
                        )}

                        {memberTodo.find((e: any) => e.todoCode == '0002000170')?.todoExecStatus ==
                            'DOING' && (
                            <Button
                                type="primary"
                                onClick={() => {
                                    navigate(
                                        `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_060_01}/${searchParams.get('settlementId')}/${searchParams.get('dealId')}`,
                                    );
                                }}
                            >
                                精算書の確認
                            </Button>
                        )}

                        {memberTodo.find((e: any) => e.todoCode == '0002000180')?.todoExecStatus ==
                            'DOING' && (
                            <Button
                                type="primary"
                                onClick={() => {
                                    navigate(
                                        `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_062_01}/${searchParams.get('settlementId')}`,
                                    );
                                }}
                            >
                                最終確認日時の登録
                            </Button>
                        )}
                        {memberTodo.find((e: any) => e.todoCode == '0002000180')?.todoExecStatus ==
                            'DONE' && (
                            <Button
                                type="primary"
                                onClick={() => {
                                    navigate(
                                        `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_062_02}/${searchParams.get('settlementId')}`,
                                    );
                                }}
                            >
                                最終確認日時の確定
                            </Button>
                        )}
                    </div>
                );
            //other
            default:
                return <div className="button-group"></div>;
        }
    };
    const TabInfomation: TabsProps['items'] = [
        {
            label: '物件情報',
            key: '1',
            children: SCU00203T1.includes(currentTodo?.todoCode) ? (
                <TAB1_1Component detailAssessment={detailRoomAssessment} options={options} />
            ) : (
                <TAB1Component
                    currentTodo={currentTodo as TodoEntity}
                    detailAssessment={detailAssessment}
                    detailRoomAssessment={detailRoomAssessment}
                    propertyUseCase={prop.propertyUseCase}
                    type={searchParams.get('type') || String(BUYER_CLASSIFICATION)}
                    bidPrice={bidPrice}
                    purchaseAmount={purchaseAmount}
                />
            ),
        },
        {
            label: 'TODOリスト',
            key: '2',
            children: <TAB2Component memberTodo={memberTodo} />,
        },
        {
            label: 'ステータス',
            key: '3',
            children: (
                <TAB3Component
                    type={searchParams.get('type') || String(BUYER_CLASSIFICATION)}
                    level1={'0-' + searchParams.get('tabIndex') || ''}
                    level2={currentTodo?.todoClassId || ''}
                />
            ),
        },
        {
            label: '申込書/契約書',
            key: '4',
            children: (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {(initFile.length == 0 && (
                        <div style={{ fontWeight: 700, fontSize: 16, marginTop: 300 }}>
                            申込書・契約書はありません
                        </div>
                    )) || (
                        <div
                            style={{
                                maxHeight: 'calc(100vh - 240px)',
                                overflow: 'auto',
                                width: '400px',
                            }}
                        >
                            <UploadImage initFile={initFile} />
                        </div>
                    )}
                </div>
            ),
        },
    ];

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexFlow: 'column',
                textAlign: 'center',
            }}
            className="CU-002-03-container"
        >
            <PageTitle title={headerComponent()} />
            <Tabs
                defaultActiveKey="1"
                className="tab-dashboard-title-container"
                items={TabInfomation}
                onChange={onChange}
            />
            <div
                style={{
                    position: activeKey != '1' ? 'absolute' : 'unset',
                    bottom: 0,
                    width: '100%',
                    marginTop: activeKey != '1' ? 'unset' : '10px',
                }}
            >
                {searchParams.get('type') == String(BUYER_CLASSIFICATION)
                    ? buttonBuyerComponent()
                    : buttonSellerComponent()}
            </div>
        </div>
    );
};

export default CU00203Page;
